<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="60%"
    append-to-body
    :before-close="handleClose"
  >
    <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
      <div>文章详情</div>
    </div>
    <div class="bj">
      <p v-html="message"></p>
      <div class="pic">
        <el-image fit="cover"
                  v-for="(e,i) in picList"
                  :key="i"
                  :src="e.src">
                  <div slot="error"
                       class="image-slot">
                    <img src="@/assets/house/onloadpicerror.png"
                         alt />
                  </div>
        </el-image>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    message:{
        type:String
    },
    picList:{
        type:Array
    },
    dialogVisible: Boolean,
  },
  watch: {
    dialogVisible: {
      deep: true,
      handler(v) {
        this.dialogVisible = v;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
/deep/ .el-dialog__header {
  height: 50px !important;
}
/deep/ .el-dialog__body{
  padding: 0 !important;
  ::-webkit-scrollbar {
    width: 8px;
    height: 32px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    height: 38px;
    /* 滚动条滑块长度 */
    background: rgba(24, 94, 212, 0.2);
  }
}
.bj {
  padding: 20px 20px 10px 20px;
  box-sizing: border-box;
  height: 650px;
  overflow-y: auto;
  .pic{
    text-align: center;
  }
}
</style>